export default __webpack_public_path__ + "static/media/global-language.1fe60fb1.svg";